"use client";
import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination } from "swiper/modules";

function SwiperSlider() {
  return (
    <>
      <section className="textimonial-section">
        <div className="container position-relative">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".custom-next",
              prevEl: ".custom-prev",
            }}
            breakpoints={{
              522: { slidesPerView: 1 },
              640: { slidesPerView: 1 },
              768: { slidesPerView: 1 },
              1024: { slidesPerView: 1 },
            }}
            className="position-relative"
          >
            <SwiperSlide>
              <div className="text-center">
                <Image
                  src="/images/testi.svg"
                  alt="textimonial icon"
                  width={24}
                  height={24}
                />
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    OneStop makes it easier than ever before for me to manage my
                    time and bookings outside of the restaurant.
                  </p>
                  <Image
                    src="/images/stars.svg"
                    alt="stars"
                    width={93}
                    height={16}
                  />
                  <h5 className="user-name">
                    Chef Jeff ( James Beard Nominated Chef )
                  </h5>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="text-center">
                <Image
                  src="/images/testi.svg"
                  alt="textimonial icon"
                  width={24}
                  height={24}
                />
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    Helps me find all of my favorite local vendors in one place,
                    from our weekly private chef to catering <br />
                    and bartenders for our house parties. Do yourself a favor
                    and try it out and save yourself some time and stress.
                  </p>
                  <Image
                    src="/images/stars.svg"
                    alt="stars"
                    width={93}
                    height={16}
                  />
                  <h5 className="user-name">Danielle M.</h5>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          {/* Buttons outside the Swiper */}
          <button className="custom-prev">
            <img
              src="/images/arrow-left.svg"
              alt="Previous"
              className="img-fluid"
            />
          </button>

          <button className="custom-next">
            <img
              src="/images/arrow-right.svg"
              alt="Next"
              className="img-fluid"
            />
          </button>
        </div>
      </section>
    </>
  );
}

export default SwiperSlider;
